<section class="app-cit-che-res">
  <h2 class="app-cit-che-res__tit">SPRAWDŹ POZOSTAŁE EVENTY</h2>

  <div class="app-cit-che-res__box">
    <div class="app-cit-che-res__box__ite">
      <img
        [src]="
          showCity() === 'MADRYT'
            ? 'assets/images/pages/cities/singapur-mini.webp'
            : 'assets/images/pages/cities/madrid-mini.webp'
        "
      />

      <div class="app-cit-che-res__box__ite__tit">
        <p class="app-cit-che-res__box__ite__tit__pro">PRO:EXPERIENCE</p>
        <h2 class="app-cit-che-res__box__ite__tit__tit">
          {{ showCity() === 'MADRYT' ? 'SINGAPUR' : 'MADRYT' }}
        </h2>
        <p class="app-cit-che-res__box__ite__tit__more">
          <a [routerLink]="['/', showCity() === 'MADRYT' ? wwwRouteSlug.SINGAPUR : wwwRouteSlug.MADRID]"
            >DOWIEDZ SIĘ WIĘCEJ</a
          >
        </p>
      </div>
    </div>

    <div class="app-cit-che-res__box__ite">
      <img src="assets/images/pages/cities/breakfast.webp" />
      <div class="app-cit-che-res__box__ite__tit">
        <p class="app-cit-che-res__box__ite__tit__pro">PRO:EXPERIENCE</p>
        <h2 class="app-cit-che-res__box__ite__tit__tit app-cit-che-res__box__ite__tit__tit--2">
          ŚNIADANIA<br />
          NETWORKINGOWE
        </h2>
        <p class="app-cit-che-res__box__ite__tit__more">
          <a [routerLink]="['/', wwwRouteSlug.ACCOUNT, wwwRouteSlug.PRO_EXPERIENCE, 'sniadanie-networkingowe']"
            >DOWIEDZ SIĘ WIĘCEJ</a
          >
        </p>
      </div>
    </div>
  </div>
</section>
